export default __webpack_public_path__ + "static/media/Chamber_Tour_De_Force.40325db9.png";